import { connect } from 'react-redux'

import {
  getProjectByProfileId,
  setFilterProjectByProfile,
} from 'reduxpath/ducks/Profile/Detail'

import FilterProjectStatus from './units'

const mapStateToProps = state => ({
  sortProjects: state.ProfileDetail.projectsProfile.sort,
  filterProjects: state.ProfileDetail.projectsProfile.filter,
  profileId: state.ProfileDetail.data.profileId,
})

const mapDispatchToProps = dispatch => ({
  setFilterProjectByProfile(sort, filter, profileId) {
    return (event) => {
      const dataFilter = {
        status: event.target.value,
      }

      const limit = 25
      const page = 0
      const qs = {
        limit,
        skip: page * limit,
      }

      if (sort.active) {
        qs.sort = {
          [sort.active]: sort[sort.active],
        }
      }

      if (dataFilter.status) {
        qs.where = {
          ...dataFilter,
        }
      }

      dispatch(setFilterProjectByProfile(dataFilter))
      dispatch(getProjectByProfileId(profileId, qs))
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterProjectStatus)
